import useResourceActionsCurriculum from './hooks/useResourceActionsCurriculum'
import s from './styles/ResourceActionsCurriculum.module.scss'

export default function ResourceActionsCurriculum({
	resources = {},
	onResourceClick,
	emptyLabel = 'Coming soon..',
}) {
	const { resources: items, hasResources, handleResourceClick } =
		useResourceActionsCurriculum(resources)

	if (!hasResources) {
		return <p className={s.comingSoon}>{emptyLabel}</p>
	}

	return (
		<div className={s.list}>
			{items.map(resource => {
				const Icon = resource.Icon

				return (
					<button
						key={resource.key}
						type="button"
						className={s.btn}
						title={resource.label}
						onClick={() => handleResourceClick(resource.key, onResourceClick)}
					>
						<Icon className={s.icon} />
						<span>{resource.label}</span>
					</button>
				)
			})}
		</div>
	)
}
